var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13,
    rx: 13,
    ry: 13,
    fill: "#16A02C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52586 8.15133C6.10208 9.29646 5.75644 10.2432 5.75644 10.2552C5.75644 10.2673 6.34853 10.2733 7.06986 10.2703L8.38028 10.2613L8.84013 8.1874C9.09259 7.04528 9.29998 6.10453 9.30298 6.0895C9.30298 6.07748 8.85215 6.06846 8.29913 6.06846H7.29828L6.52586 8.15133Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63357 6.08419C9.63357 6.10824 8.7319 10.1628 8.71387 10.2229C8.69884 10.274 8.77398 10.277 10.0213 10.277H11.3437L11.3587 10.1177C11.3858 9.89528 11.6473 6.28256 11.6473 6.16534V6.06916H10.6404C10.0874 6.06916 9.63357 6.07518 9.63357 6.08419Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9772 6.14117C11.9772 6.18024 11.9111 7.12099 11.8269 8.23306C11.7458 9.34512 11.6767 10.2588 11.6767 10.2648C11.6767 10.2708 12.2718 10.2769 13.0021 10.2769H14.3276L14.3095 10.0725C14.2795 9.77492 14.021 6.23133 14.021 6.14417V6.06903H12.9991H11.9772V6.14117Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3526 6.16481C14.3526 6.28504 14.6141 9.89775 14.6411 10.1172L14.6562 10.2765H15.9786C17.2259 10.2765 17.301 10.2735 17.286 10.2224C17.277 10.1953 17.0726 9.27259 16.8322 8.17255C16.5887 7.0725 16.3874 6.14979 16.3783 6.11973C16.3633 6.07164 16.2882 6.06863 15.3565 6.06863H14.3526V6.16481Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6968 6.07437C16.6998 6.08038 16.9072 7.02414 17.1597 8.17227L17.6195 10.2612L18.933 10.2702C19.6543 10.2732 20.2434 10.2672 20.2434 10.2551C20.2434 10.2401 19.8977 9.29336 19.474 8.14823L18.7015 6.06836H17.6977C17.1477 6.06836 16.6968 6.07137 16.6968 6.07437Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70526 10.7141C5.73832 10.9124 5.89761 11.201 6.06893 11.3753C6.57687 11.8802 7.4064 11.8862 7.93537 11.3843C8.10969 11.219 8.25696 10.9605 8.30806 10.7321L8.33511 10.6059H7.01267H5.68723L5.70526 10.7141Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70472 10.734C8.88205 11.5456 9.81677 11.9904 10.5892 11.6297C10.9318 11.4704 11.2504 11.0617 11.3075 10.716L11.3256 10.6078H10.0001H8.67767L8.70472 10.734Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6778 10.6333C11.6778 10.7114 11.798 11.027 11.8701 11.1443C12.3901 11.9618 13.6103 11.9618 14.1303 11.1443C14.2024 11.027 14.3226 10.7114 14.3226 10.6333C14.3226 10.6183 13.7756 10.6063 13.0002 10.6063C12.2248 10.6063 11.6778 10.6183 11.6778 10.6333Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6919 10.7151C14.725 10.9135 14.8842 11.202 15.0556 11.3763C15.7829 12.1007 17.0723 11.734 17.2917 10.7331L17.3217 10.6069H15.9993H14.6739L14.6919 10.7151Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6947 10.732C17.7638 11.0475 17.9742 11.3511 18.2447 11.5345C18.7617 11.8861 19.489 11.817 19.9308 11.3752C20.1021 11.2008 20.2614 10.9123 20.2945 10.7139L20.3125 10.6057H18.9871H17.6646L17.6947 10.732Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38671 11.3373C8.15227 11.672 7.72549 11.9519 7.32875 12.0212L7.1394 12.0558V15.3393V18.6228H9.09301H11.0466V16.0289V13.4321L11.1127 13.3888C11.1728 13.3484 11.4013 13.3427 13.0002 13.3427C14.5992 13.3427 14.8276 13.3484 14.8877 13.3888L14.9538 13.4321V16.0289V18.6228H16.9074H18.861V15.3393V12.0558L18.6747 12.0212C18.278 11.9519 17.8181 11.6518 17.5987 11.3229C17.5446 11.2421 17.4965 11.1786 17.4905 11.1786C17.4875 11.1786 17.4334 11.2479 17.3763 11.3287C17.0637 11.7817 16.5588 12.0442 16.0088 12.0442C15.6872 12.0414 15.5399 12.0096 15.2574 11.8798C15.0139 11.7701 14.6863 11.4816 14.5781 11.2854C14.5451 11.2277 14.509 11.1786 14.497 11.1786C14.485 11.1786 14.4519 11.2219 14.4248 11.271C14.3467 11.4152 14.0281 11.7182 13.8418 11.8278C13.3398 12.1193 12.6606 12.1193 12.1587 11.8278C11.9603 11.7124 11.7018 11.4701 11.5966 11.2998C11.5545 11.2335 11.5125 11.1786 11.5004 11.1786C11.4914 11.1786 11.4554 11.2277 11.4223 11.2854C11.3141 11.4816 10.9865 11.7701 10.7431 11.8798C10.4605 12.0096 10.3133 12.0414 9.99167 12.0442C9.44165 12.0442 8.93672 11.7817 8.62414 11.3287C8.56704 11.2479 8.51294 11.1786 8.50693 11.1786C8.50092 11.1786 8.44682 11.2508 8.38671 11.3373Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7124 15.8699V18.623H12.9649H15.2175V15.8699V13.1168H12.9649H10.7124V15.8699Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.13934,
    y: 18.9322,
    width: 11.7217,
    height: 0.998285,
    rx: 0.109918,
    fill: "#FFF536"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.625,
    height: 14.625,
    fill: "white",
    transform: "translate(5.68774 5.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeClosed);
export default __webpack_public_path__ + "static/media/trade_closed.18aaec9045057a716f0b5468c0b5c82d.svg";
export { ForwardRef as ReactComponent };